import logo from '../assets/logo.png';

function Navbar() {
  const navbarStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#dadada',
    padding: '10px 20px',
    color: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  };

  const linkStyle = {
    color: '#fff',
    textDecoration: 'none',
    margin: '0 10px',
    fontSize: '16px',
    fontWeight: '500',
  };

  return (
    <nav style={navbarStyle}>
      <div><img className="logoStyle" src={logo} alt="Logo"/></div>
      <div>
        {/* <a href="/" style={linkStyle}>На главную</a> */}
        {/* <a href="/about" style={linkStyle}>About</a> */}
        <a href="/employee-production-page" style={linkStyle}>Наряды</a>
        <a href="/products" style={linkStyle}>Продукты</a>
        <a href="/employees" style={linkStyle}>Сотрудники</a>
      </div>
    </nav>
  );
}

export default Navbar;